module.exports = __webpack_public_path__ + "img/77.1a21b4e1.png";